import React, { useEffect, useState } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import useAuth from "../../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";

function Dashboard() {
  const { user, loading } = useAuth();
  const [profile, setProfile] = useState(null);
  const [club, setClub] = useState(null);
  const [team, setTeam] = useState(null);
  const [game, setGame] = useState(null);
  const [dataLoading, setDataLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDemoData = async () => {
      if (!user) return;
      setDataLoading(true);

      // 1. Fetch user profile
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);
      if (!userSnap.exists()) return setDataLoading(false);
      const userData = userSnap.data();
      setProfile(userData);

      // 2. Fetch demo club
      const clubRef = doc(db, "clubs", userData.clubId);
      const clubSnap = await getDoc(clubRef);
      setClub(clubSnap.exists() ? clubSnap.data() : null);

      // 3. Fetch demo team
      const teamRef = doc(db, "teams", userData.teamId);
      const teamSnap = await getDoc(teamRef);
      setTeam(teamSnap.exists() ? teamSnap.data() : null);

      // 4. Fetch demo game (if any)
      const gameRef = doc(db, "games", `demoGame_${user.uid}`);
      const gameSnap = await getDoc(gameRef);
      setGame(gameSnap.exists() ? gameSnap.data() : null);

      setDataLoading(false);
    };

    if (user) fetchDemoData();
  }, [user]);

  // Handler for starting the match
  const handleStartMatch = async () => {
    if (!user || !game) return;
    try {
      // Update game status to "live"
      await updateDoc(doc(db, "games", `demoGame_${user.uid}`), {
        status: "live",
      });
      // Redirect to the match screen
      navigate("/match");
    } catch (err) {
      alert("Error starting match: " + err.message);
    }
  };

  if (loading || dataLoading) return <div>Loading demo dashboard...</div>;
  if (!user) return <div>Please <Link to="/login">log in</Link>.</div>;
  if (!profile) return <div>Profile not found.</div>;

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: 24 }}>
      <h2>Welcome, Coach!</h2>
      <div style={{ marginBottom: 16 }}>
        <b>Email:</b> {user.email}
      </div>

      {club && (
        <div style={{ marginBottom: 16, padding: 12, border: "1px solid #eee", borderRadius: 8 }}>
          <h3>Club: {club.clubName}</h3>
        </div>
      )}

      {team && (
        <div style={{ marginBottom: 16, padding: 12, border: "1px solid #eee", borderRadius: 8 }}>
          <h3>Team: {team.teamName}</h3>
          <div>
            <b>Squad:</b>
            <ul>
              {team.squad.map((p) => (
                <li key={p.playerId}>
                  {p.name} {p.position && <span>({p.position})</span>}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {game && (
        <div style={{ marginBottom: 16, padding: 12, border: "1px solid #eee", borderRadius: 8 }}>
          <h3>Demo Match</h3>
          <div><b>Opponent:</b> {game.opponent}</div>
          <div><b>Date:</b> {game.date} <b>Time:</b> {game.time}</div>
          <div><b>Match Type:</b> {game.matchType}</div>
          <div><b>Status:</b> {game.status}</div>
          <div><b>Quarter Length:</b> {game.quarterLength} min</div>
          <div><b>Starting Lineup:</b>
            <ul>
              {game.startingLineup.map((p) => (
                <li key={p.playerId}>
                  {p.name} ({p.position})
                </li>
              ))}
            </ul>
          </div>
          <div><b>Subs:</b> {game.subs.map((s) => s.name).join(", ")}</div>
          <div style={{ marginTop: 12 }}>
            <b>Score:</b> {game.homeScore} - {game.awayScore}
          </div>

          {/* EDIT/SETUP AND START MATCH BUTTONS */}
          <div style={{ marginTop: 16 }}>
            <Link to="/setup-match">
              <button style={{ marginRight: 8 }}>Edit/Setup Match</button>
            </Link>
            {game.status !== "live" && (
              <button onClick={handleStartMatch}>Start Match</button>
            )}
          </div>
        </div>
      )}

      <div style={{ textAlign: "center", marginTop: 24 }}>
        <button
          style={{ padding: "10px 24px", fontWeight: 700, fontSize: 18, borderRadius: 8, background: "#3b82f6", color: "#fff" }}
          onClick={() => alert("Upgrade flow coming soon!")}
        >
          Upgrade and Create Your Own Club/Team
        </button>
      </div>
    </div>
  );
}

export default Dashboard;
